import {ROW_LIMIT} from './AnalyticsWarehouseConstants';
import {RunQueryOutput} from './AnalyticsWarehouseTypes';

export default function getWarningMessageForRowLimit(runQueryOutput: RunQueryOutput): string | null {
  return runQueryOutput.isTruncated ? `Query limit of ${ROW_LIMIT} automatically added.` : null;
}
